/**
 * Haptics - Vibrations-Feedback für Mobile-Geräte
 * Nur auf Geräten mit Vibration API verfügbar
 */

/**
 * Prüft, ob Vibration unterstützt wird
 */
function isVibrationSupported() {
  return typeof navigator !== 'undefined' && 'vibrate' in navigator;
}

/**
 * Kurze Vibration für Feedback
 * @param {number} duration - Dauer in ms (default: 10)
 */
function light(duration = 10) {
  if (isVibrationSupported()) {
    navigator.vibrate(duration);
  }
}

/**
 * Mittlere Vibration für Bestätigung
 * @param {number} duration - Dauer in ms (default: 25)
 */
function medium(duration = 25) {
  if (isVibrationSupported()) {
    navigator.vibrate(duration);
  }
}

/**
 * Starke Vibration für wichtige Aktionen
 * @param {number} duration - Dauer in ms (default: 50)
 */
function heavy(duration = 50) {
  if (isVibrationSupported()) {
    navigator.vibrate(duration);
  }
}

/**
 * Erfolgs-Pattern (doppelte Vibration)
 */
function success() {
  if (isVibrationSupported()) {
    navigator.vibrate([15, 50, 15]);
  }
}

/**
 * Fehler-Pattern (schnelle Triple-Vibration)
 */
function error() {
  if (isVibrationSupported()) {
    navigator.vibrate([10, 30, 10, 30, 10]);
  }
}

/**
 * Swipe-Threshold erreicht
 */
function swipeThreshold() {
  if (isVibrationSupported()) {
    navigator.vibrate(8);
  }
}

const haptics = {
  isSupported: isVibrationSupported,
  light,
  medium,
  heavy,
  success,
  error,
  swipeThreshold,
};

export default haptics;
